<script>
export default {
  name: "eo-picture-mixin",
  methods: {
    pictureFullCopyRight(picture) {
      const copyRight = [];

      if (picture && picture.license) {
        if (picture.license.type) copyRight.push(picture.license.type);
        if (picture.license.author) copyRight.push(picture.license.author);
        if (picture.license.source) copyRight.push(picture.license.source);
      }

      return copyRight.join(" – ");
    },
    isImageFilename(str) {
      const suffix = str
        .trim()
        .split(".")
        .pop();
      if (!suffix) {
        return false;
      }
      return ["jpg", "jpeg", "png", "gif", "webp"].includes(
        suffix.toLowerCase()
      );
    }
  }
};
</script>
